module.exports = __webpack_public_path__ + "img/pa_get.f0dc365.png";